import { type VoidFunctionComponent } from 'react';
import { ListGroup, ListGroupItem } from 'react-bootstrap';
import type { NoticeMatch } from '../../../../shared/types/routes/revisions';
import Loader from '../../generic/Loader';
import ManageNoticeFile from './ManageNoticeFile';

type NoticeFilesProps = {
  isLoading: boolean;
  isError: boolean;
  notices: Record<string, NoticeMatch>;
  onChange: (change: NoticeMatch) => void;
};

const NoticeFiles: VoidFunctionComponent<NoticeFilesProps> = ({ isLoading, isError, notices, onChange }) => {
  if (isLoading) {
    return (
      <div>
        <div className="fossa-form__label__text">Notice Files</div>
        <ListGroup>
          <ListGroupItem><Loader /></ListGroupItem>
        </ListGroup>
      </div>
    );
  }

  if (isError) {
    return (
      <div>
        <div className="fossa-form__label__text">Notice Files</div>
        <ListGroup>
          <ListGroupItem>
            <div>Unfortunately FOSSA can not load this component&apos;s notice files. Please try again later.</div>
          </ListGroupItem>
        </ListGroup>
      </div>
    );
  }

  return (
    <div>
      <div className="fossa-form__label__text">Notice Files</div>
      {Object.keys(notices).length > 0 ? (
        <ListGroup>
          {Object.values(notices).map(file => <ManageNoticeFile key={file.id} file={file} onChange={onChange} />)}
        </ListGroup>
      ) : (
        <ListGroup>
          <ListGroupItem>
            <div>FOSSA does not currently have any NOTICE file data for this dependency.</div>
          </ListGroupItem>
        </ListGroup>
      )}
    </div>
  );
};

export default NoticeFiles;
